import React from 'react';
//import logo from './assets/visioN.svg';
import '../App.less';
import { Layout, Menu, Button, Image } from 'antd';

import { Link } from "react-router-dom";

const { Header } = Layout;

function WebHeader() {
  return (
    <div>
        <Header> 
          <div className="logo" />
          <Menu mode="horizontal">
            <Menu.Item key="1" style={{float: 'right'}}>about me</Menu.Item>
          </Menu>          
        </Header>
    </div>
  );
}

export default WebHeader;
